import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-clock',
  templateUrl: './clock.component.html',
})
export class ClockComponent implements OnInit, OnDestroy {
  @Input() location: string;
  @Input() timezone: string;

  time: string;
  timer;

  isRunning = true;
  timerId: any;

  constructor() {}

  @ViewChild('hourHand') hourHand: ElementRef;
  @ViewChild('minuteHand') minuteHand: ElementRef;
  @ViewChild('secondHand') secondHand: ElementRef;

  date: Date;
  hour: number;
  minute: number;
  moment: string;

  ngOnInit() {
    this.timerId = this.getTime();
    this.timer = setInterval(() => {
      let currTimeStr = new Date().toLocaleString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: this.timezone,
      });
      this.time = currTimeStr.split(' ')[0];
      this.moment = currTimeStr.split(' ')[1];
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }

  // ngAfterViewInit() {
  //   this.timerId = this.getTime();
  // }

  getTime() {
    return setInterval(() => {
      if (this.time) {
        const times = this.time.split(':');
        this.hour = parseInt(times[0]);
        this.minute = parseInt(times[1].slice(0, 2));
      }
      this.animateAnalogClock();
    }, 1000);
  }

  animateAnalogClock() {
    this.hourHand.nativeElement.style.transform = `translate3d(-100%, -100%, 0) rotate(${this.hour * 30 +
      this.minute * 0.5}deg)`;
    this.minuteHand.nativeElement.style.transform = `translate3d(-100%, -100%, 0) rotate(${this.minute * 6}deg)`;
    // console.log(this.hourHand.nativeElement);
  }

  toggle() {
    if (this.isRunning) {
      clearInterval(this.timerId);
    } else {
      this.getTime();
    }

    this.isRunning = !this.isRunning;
  }
}
